import { Component, OnInit, Input, Output, EventEmitter, ViewChildren, ChangeDetectorRef, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ajaxservice } from '../../../../app/services/ajaxservice';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgOtpInputComponent, NgOtpInputConfig, NgOtpInputModule } from  'ng-otp-input';
import { LoaderComponent } from '../../../../app/views/pages/loader/loader.component';
import { ComponentPortal } from '@angular/cdk/portal';
import { OverlayRef, Overlay } from '@angular/cdk/overlay';
import * as objectPath from 'object-path';
import { LayoutConfigService } from '../../../core/_base/layout';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MenuConfigService } from '../../../core/_base/layout/services/menu-config.service';
interface Tab {
	title: string;
	type: string;
  }
@Component({
  selector: 'kt-webform',
  templateUrl: './webform.component.html',
  styleUrls: ['./webform.component.scss']
})
// export class Setting {
//   inputStyles?: { [key: string]: any };
//   wrapperStyles?: { [key: string]: any };
//   allowKeyCodes?: string[];
//   length: number;
//   numbersOnly?: boolean;
//   inputClass?: string;
//   wrapperClass?: string;
//   timer?: number;
//   btnClass?: string;
//   timerType?: number; //  0: secs, 1: mins
// }
export class WebformComponent implements OnInit {
  private headerMenus: any;
  private asideMenus: any;
  otp: string = '';
  showForm: boolean = true;
  showSuccess: boolean = false;
  showReset: boolean = false;
  remainingTime: number = 25;
  countdownInterval: any;
  tabs: Tab[] = [
    { title: 'Consumer', type: '2' },
    { title: 'Enterprise', type: '1' },
  ];
  selectedTab: number = null;
  active = 1;
  today: number = Date.now();
  fluid: boolean;
//   @Input() setting: Setting = { 
// 		length: 4, 
// 		timer: 0,
// 		timerType: 0
// 	};
// /**
// 	 * Component constructor
// 	 *
// 	 * @param router: Router
// 	 * @param auth: AuthService
// 	 * @param authNoticeService: AuthNoticeService
// 	 * @param translate: TranslateService
// 	 * @param store: Store<AppState>
// 	 * @param fb: FormBuilder
// 	 * @param cdr
// 	 * @param route
// 	 * @param menuConfigService: MenuConfigService
// 	 * @param MenuHorizontalService:MenuHorizontalService
// 	 * @param authService
	
	 
// 	 */
@ViewChild('ngOtpInput') ngOtpInputRef:any;     // use the otpinput field changes work on harish
public settings = {
    length: 6,
    numbersOnly: true,
    timer: 5,
    timerType: 2,
  };
	// @Output() onValueChange = new EventEmitter<any>();
	// @ViewChildren(CounterDirective) CounterDirective;
	timerValue: number = 30;
//   interval: any;
  countdownValue: number = 30;
  interval: any;
	// inputControls: FormControl[] = new Array(this.setting.length);
	componentKey = Math.random().toString(36).substring(2) + (new Date()).getTime().toString(36);
	public counter: number;
	currentJustify = 'center';
	mobile_no: number;
	// otp_no:any;
	user_string: any;
	user_info: any;
	otpCode: string = '';
	otpCodeDigits: string[] = new Array(6).fill('');
	otpbutton: boolean = false;
	otpdigit: boolean = false;
	otpsubmit: boolean = false;
	validation_data: any;
	user_error: string;
	resendbutton: boolean = true;
	enterprise_mobile_no: number;
	enterprise_otpCode: string;
	otpsend_details: any;
	LoaderComponentPortal: ComponentPortal<LoaderComponent>;
	overlayRef: OverlayRef;         // for loader
	otpConfig :NgOtpInputConfig = {
		allowNumbersOnly: true,
		length: 6,
		isPasswordInput: false,
		disableAutoFocus: false,
		placeholder: '-',
		inputClass: 'otp-box'
	  };

	  @ViewChild('ngOtpInput', { static: false}) ngOtpInput:NgOtpInputComponent;
	customer_status: any;
	customer_err: string;
	cus_code: string = '';
	site: any = [];
	site_id: any = null;
	entersendotp_details: any;
	sites: any;
	enterotp_details: any;
	mobileNoError: string;
  
  constructor(private chRef: ChangeDetectorRef,public ajax: ajaxservice,
	private router: Router,private toastr: ToastrService, 
	private overlay: Overlay,private layoutConfigService: LayoutConfigService,
    public menuConfigService: MenuConfigService,) { 
	
  }

  selectTab(index: number): void {
    this.selectedTab = index;
  }
  ngOnInit() {
	this.overlayRef = this.overlay.create({
		positionStrategy: this.overlay.position().global().centerHorizontally().centerVertically(),
		hasBackdrop: true,
	  });
	this.LoaderComponentPortal = new ComponentPortal(LoaderComponent);
	this.customer_err = '';
	const config = this.layoutConfigService.getConfig();
		this.fluid = objectPath.get(config, 'footer.self.width') === 'fluid';
	this.otpsend_details = "";
  }

  onOtpChange(otp) {
	if(otp.length == (this.otpCodeDigits.length)) {
		this.otpsubmit = false;
		this.otpCode = otp;
		this.user_error ='';
	}
  }

  startCountdown(): void {
    this.interval = setInterval(() => {
      this.countdownValue--;
	  this.chRef.detectChanges();
      if (this.countdownValue === 0) {
		this.resendbutton = true;
        clearInterval(this.interval);
		this.chRef.detectChanges();
      }
    }, 1000);
  }
  onOtpInputChange() {
    // Update the array of digits for displaying in boxes
	this.otpCodeDigits = this.otpCode.split('');
  }

  focusInput(index: number) {
	console.log("focusinput")
    // Focus on the corresponding input field when a box is clicked
    if (index >= 0 && index < this.otpCodeDigits.length) {
      const inputIndex = this.otpCodeDigits.findIndex((digit) => digit === '');
	  console.log("107")
      if (inputIndex !== -1) {
        const inputElement = document.querySelector(
          `.otp-input:nth-child(${inputIndex + 1})`
        ) as HTMLInputElement;
        if (inputElement) {
          inputElement.focus();
        }
      }
	  console.log("116");
	  if(index == (this.otpCodeDigits.length - 1)) {
		this.otpsubmit = false;
	  }
    }	
  }
  
  ngOnDestroy(): void {
    clearInterval(this.interval);
  }
  startTimer(): void {
    this.interval = setInterval(() => {
      this.timerValue++;
    }, 1000);
  }
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
//   ngOnDestroy(): void {
//     clearInterval(this.interval);
//   }
  public ngAfterViewInit(): void {
		let containerItem = document.getElementById(`c_${this.componentKey}`);
		if (containerItem) {
			let ele: any = containerItem.getElementsByClassName('.otp-input')[0]
			if (ele && ele.focus) {
				ele.focus();
			}
		}
	}

	private getControlName(idx) {
		return `ctrl_${idx}`;
	}

	isLeftArrow(e) {
		return this.isKeyCode(e, 37);
	}

	isRightArrow(e) {
		return this.isKeyCode(e, 39);
	}

	isBackspaceOrDelete(e) {
		return e.key === "Backspace" || e.key === "Delete" || this.isKeyCode(e, 8) || this.isKeyCode(e, 46);
	}

	isKeyCode(e, targetCode) {
		var key = e.keyCode || e.charCode;
		if(key == targetCode) { return true; }
		return false;
	}

	keyUp(e, inputIdx: number) {
		let nextInputId = this.appendKey(`otp_${inputIdx + 1}`);
		let prevInputId = this.appendKey(`otp_${inputIdx - 1}`);
		if (this.isRightArrow(e)) {
			this.setSelected(nextInputId);
			return;
		}
		if (this.isLeftArrow(e)) {
			this.setSelected(prevInputId);
			return;
		}
		let isBackspace = this.isBackspaceOrDelete(e);
		if (isBackspace && !e.target.value) {
			this.setSelected(prevInputId);
			this.rebuildValue();
			return;
		}
		if (!e.target.value) {
			return;
		}
		// if (this.isValidEntry(e)) {
		// 	this.focusTo(nextInputId);
		// }
		this.rebuildValue();
	}

	appendKey(id) {
		return `${id}_${this.componentKey}`;
	}

	setSelected(eleId) {
		this.focusTo(eleId);
		let ele: any = document.getElementById(eleId);
		if (ele && ele.setSelectionRange) {
			setTimeout(() => {
				ele.setSelectionRange(0, 1);
			}, 0);
		}
	}

	isValidEntry(e) {
		var inp = String.fromCharCode(e.keyCode);
		var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
		// return isMobile || /[a-zA-Z0-9-_]/.test(inp) || (this.setting.allowKeyCodes && this.setting.allowKeyCodes.includes(e.keyCode)) || (e.keyCode >= 96 && e.keyCode <= 105);
	}

	focusTo(eleId) {
		let ele: any = document.getElementById(eleId);
		if (ele) {
			ele.focus();
			ele.selectionStart = ele.selectionEnd = 100;
		}
	}

	rebuildValue() {
		let val = '';
		// this.keysPipe.transform(this.otpForm.controls).forEach(k => {
		// 	if (this.otpForm.controls[k].value) {
		// 		val += this.otpForm.controls[k].value;
		// 	}
		// });
		// this.onValueChange.emit(val);
	}

	public onCounterChange(e): void {
		this.counter = e;
		if(this.counter == 0) {
			// this.onValueChange.emit(-1);
		}
	}

	ressendOtp(): void {
		// this.CounterDirective.first.startTimer();
		// this.onValueChange.emit(-2);
	}

	public formatSecsToMins(time) {   
		// Hours, minutes and seconds
		var hrs = ~~(time / 3600);
		var mins = ~~((time % 3600) / 60);
		var secs = ~~time % 60;
	
		// Output like "1:01" or "4:03:59" or "123:03:59"
		var ret = "";
		if (hrs > 0) {
			ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
		}
		ret += "" + mins + ":" + (secs < 10 ? "0" : "");
		ret += "" + secs;
		return ret;
	}
  startOtpTimer() {
    this.countdownInterval = setInterval(() => {
      this.remainingTime--;
      if (this.remainingTime === 0) {
        this.showForm = false;
        this.showReset = true;
        clearInterval(this.countdownInterval);
      }
    }, 1000); // Update the countdown every 1 second (1000ms)
  }

  tabChange(event) { // event triggers when the tab item is clicked. By: Monisha
	console.log(event.nextId)
	if(event.nextId =='2'){
		this.active = 2;
	}
	else{
		this.active = 1
	}
	this.otpdigit = false;
	this.mobile_no = null;
	this.otpbutton = false;
	this.user_error = '';
	this.otpCode = '';
	this.customer_err = '';
	this.otpCodeDigits = new Array(6).fill('');
	this.cus_code = '';
	this.site_id = null;
	this.site = "";
	this.otpsend_details = "";
}

get_site_details() {
	var data = { "customer_code": this.cus_code ,"customer_type":"1"};
    var url = 'get_site_details/';                                         //api url of add
	this.site_id = null;
    this.ajax.postdata(url, data).subscribe((result) => {
      //if sucess
      if (result.response.response_code == "200" || result.response.response_code == "400") {
        this.site = result.response.data;
		this.chRef.detectChanges();
      }
      //if error
      else if (result.response.response_code == "500") {
        this.toastr.error(result.response.message, 'Error');        //toastr message for error
      }
      else {
        this.toastr.error(result.response.message, 'Error');        //toastr message for error
      }
    }, (err) => {
      console.log(err);                                             //prints if it encounters an error
    });
}

  submitOtp() {
    // Simulate OTP verification logic here
    if (this.otp === '123456') { // Replace with your actual OTP logic
      this.showForm = false;
      this.showSuccess = true;
      clearInterval(this.countdownInterval);
    } else {
      // Handle incorrect OTP
      alert('Incorrect OTP. Please try again.');
    }
  }

  resetForm() {
    this.otp = '';
    this.showForm = true;
    this.showReset = false;
    this.remainingTime = 30;
    this.startOtpTimer();
  }
  submit(){     // otp submit function
	if(this.otpCode !=null || this.otpCode != "" ){
		// if(this.active == 2){
			var mob:any = this.mobile_no
			var customer_number = mob; // customer_mobile: number  
			localStorage.setItem('unreg_mob', mob);
			var otp = this.otpCode;   // otp_number                          
			var url = 'submit_otp/?';             // api url for getting the details with using post params
			var id = "customer_number";
			var node_id = "otp";
			var id2 = "customer_type";
			var value2 = this.active;
			console.log("submit_otp")
			console.log(url, id, customer_number,node_id,otp,id2,value2,'url, id, customer_number,node_id,otp,id2,value2')
			var data = {
				"customer_number":customer_number,"otp":this.otpCode,"customer_type":value2
			}
			console.log(data)
			// this.ajax.getdataparams(url,data).subscribe((result)=>{
			this.ajax.getdatawith3params(url,id,customer_number,node_id,otp,id2,value2).subscribe((result) => {
				console.log(result,'result')
			if (result.response.response_code == "200") {           //api success
				this.user_info = result.response;
				// console.log(this.user_info,'this.user_info.role.role_id   431')
				console.log(this.user_info.role.role_id,'this.user_info.role.role_id 432')
				// this.role_id = localStorage.getItem('pro_role_id');
				localStorage.setItem('pro_role_id',this.user_info.role.role_id);
				localStorage.setItem('user_code', result.response.customer_code);
        localStorage.setItem('user_name', result.response.customer_name);
        localStorage.setItem('user_email', result.response.customer_email);

				// localStorage.setItem('reg_cust_code', this.user_info.customer_code);
				// localStorage.setItem('reg_cust_name', this.user_info.customer_name);    // set item of customer name work by harish
				// setTimeout(() => {
				// 	console.log(objectPath,"objectpath326")
				// 	this.headerMenus = objectPath.get(this.menuConfigService.getMenus(), 'header.items');
				// 	this.asideMenus = objectPath.get(this.menuConfigService.getMenus(), 'aside.items');
					// localStorage.setItem('pro_asideMenus', JSON.stringify(this.asideMenus));
				// 	console.log(this.headerMenus,"this.headerMenus")
				// 	console.log(this.headerMenus,"this.headerMenus")
				// }, 1000);
				console.log(this.customer_status,'this.customer_status')
				if(this.customer_status == "Yes"){                // if for registered customer
					localStorage.setItem('reg_cust_code', this.user_info.customer_code);
					localStorage.setItem('reg_cust_name', this.user_info.customer_name);    // set item of customer name work by harish
					this.router.navigateByUrl('customer/dashboard');
					console.log(this.user_info.customer_code)
				}
				else{
					console.log("No")
					localStorage.setItem('reg_cust_code', this.user_info.customer_code);
					localStorage.setItem('reg_cust_name', this.user_info.customer_name);    // set item of customer name work by harish
					console.log("asidgasdkgkiasgkdagsd")
					// this.router.navigateByUrl('customer/dashboard');
					this.router.navigateByUrl('customer/new_enduser');

				}
				
			}
			else if(result.response.response_code == "500"){         //else for api error message
				console.log("dsfgskdfgjsdgfjsdhfhg 463")
				this.user_error = result.response.message;
				this.chRef.detectChanges();
			}
			})
		// }
	}
	else{

	}
 
  }
  public onInputChange(e) {
    console.log(e,"ghdfg");
    if (e.length == this.settings.length) {
      // e will emit values entered as otp and,
      console.log('otp is', e);
    } else if (e == -1) {
      // if e == -1, timer has stopped
      console.log(e, 'resend button enables');
    } else if (e == -2) {
      // e == -2, button click handle
      console.log('resend otp');
    }
  }
  getnumber(){
	if((this.mobile_no != null && this.mobile_no.toString().length == 10)&&(this.mobile_no[0]=='6'||this.mobile_no[0]=='7'||this.mobile_no[0]=='8'||this.mobile_no[0]=='9')){
		this.mobileNoError = "";
		this.otpbutton = true;
	   this.resendbutton = false;
	} else {
		if((this.mobile_no[0]!='6' && this.mobile_no[0]!='7' && this.mobile_no[0]!='8' && this.mobile_no[0]!='9') && (this.mobile_no.toString().length == 10)){
			this.mobileNoError = "Enter Correct Mobile number";
		}
		this.otpbutton = false;
	   this.resendbutton = true;
	}
  }
  submitsendotp(){   //otp send api  
	this.overlayRef.attach(this.LoaderComponentPortal);
	this.otpbutton = false;
	this.otpsubmit = true;
	this.timerValue = 30;
	this.countdownValue = 30;
	this.startOtpTimer();
	this.startTimer();
	if(this.active == 1){
		var number = this.mobile_no;
	} else {
		number = null;
	}                          
    var url = 'cus_otp_send/?';             // api url for getting the details with using post params
    var id = "customer_number";
	var id2 ="customer_type";
	var value2 = this.active;
	var cus_id = this.cus_code;
	var siteid = this.site_id;
    this.ajax.getdatalocation(url, id, number,value2,id2).subscribe((result) => {
      if (result.response.response_code == "200") {
		this.overlayRef.detach();
        this.otpsend_details = result.response.cus_details;
		this.customer_status = this.otpsend_details.customer_exists;
		this.toastr.success(result.response.message, 'Success');        //toastr message for success
		this.otpdigit = true;
		this.startCountdown();
      }
	  else if (result.response.response_code == "500") {                 //if failiure
		this.overlayRef.detach();
		this.customer_err = result.response.message;
		console.log(this.customer_err )
		this.toastr.error(result.response.message, 'Error');            //toastr message for error
	  }
    })
  }
 entersendotp(){   // enterprice otp send api
	localStorage.setItem('enduser_number', "");  //set the enduser number by harish
	this.overlayRef.attach(this.LoaderComponentPortal);
	this.otpsubmit = true;
	this.timerValue = 30;
	this.countdownValue = 30;
	this.startOtpTimer();
	this.startTimer();
	if(this.active == 1){
		var number = this.mobile_no;
	} else {
		number = null;
	}                          
    var url = 'enterprise_otp_send/?';             //enterprice otp send api 
    var data = { "customer_code": this.cus_code , "site_id":this.site_id};  // api url for getting the details with using post params
	this.ajax.postdata(url, data).subscribe((result) => {
      if (result.response.response_code == "200") {
		this.overlayRef.detach();
        this.otpsend_details = result.response.cus_details;
		localStorage.setItem('enduser_number', this.otpsend_details.customer_number);
		this.toastr.success(result.response.message, 'Success');        //toastr message for success
		this.otpdigit = true;
		this.startCountdown();
      }
	  else if (result.response.response_code == "500") {                 //if failiure
		this.overlayRef.detach();
		this.customer_err = result.response.message;
		this.toastr.error(result.response.message, 'Error');            //toastr message for error
		this.chRef.detectChanges();
	  }
    })
  }
  resendotp(){   // function for resend otp click
	this.overlayRef.attach(this.LoaderComponentPortal);
	this.user_error ='';
	this.otpCode = '';
	this.ngOtpInputRef.setValue("");
	this.countdownValue = 30;
	console.log(this.customer_status)
	if(this.customer_status == "No"){
		var mob = this.mobile_no
		var number = mob; // mobile number get        
		var id2 ="customer_type";
		var value2 = this.active;                  
		var url = 'cus_otp_resend/?';             // api url for getting the details with using post params
		var id = "customer_number";
		this.ajax.getdatalocation(url, id, number,value2,id2).subscribe((result) => {
			if (result.response.response_code == "200") {
			  this.overlayRef.detach();
			  this.otpsend_details = result.response.data;
			  this.toastr.success(result.response.message, 'Success');        //toastr message for success
			  this.resendbutton = false;
			  this.startCountdown();
			}
			else if (result.response.response_code == "500") {                 //if failiure
			  this.overlayRef.detach();
			  this.customer_err = result.response.message;
			  this.toastr.error(result.response.message, 'Error');            //toastr message for error
			}
		  })
	}
	else{
		localStorage.setItem('enduser_number', "");  //set the enduser number by harish
		var url = 'enterprise_otp_send/?';             // api url for getting the details with using post params
        var data = { "customer_code": this.cus_code , "site_id":this.site_id};
		this.ajax.postdata(url, data).subscribe((result) => {
		if (result.response.response_code == "200") {
			this.overlayRef.detach();
			this.enterotp_details = result.response.cus_details;
			localStorage.setItem('enduser_number', this.enterotp_details.customer_number);
			this.toastr.success(result.response.message, 'Success');        //toastr message for success
			this.otpdigit = true;
			this.resendbutton = false;
			this.startCountdown();
		}
		else if (result.response.response_code == "500") {                 //if failiure
			this.overlayRef.detach();
			this.customer_err = result.response.message;
			this.toastr.error(result.response.message, 'Error');            //toastr message for error
		}
		})

	}
  }
  onchangecusid(){                //chnage customer id work by harish
	this.otpsend_details =''
	this.site_id = null;
	this.site = "";
	this.user_error ="";
	this.otpdigit = false;
	this.chRef.detectChanges();
  }
  onchangecusno(){                   //change customer number empty on error msg work by harish
	this.customer_err ="";
	this.user_error ="";
	this.otpdigit = false;
	this.chRef.detectChanges();
  }
}